// @flow
export const checkValidity = (type: string, fields: Array<Object>): boolean => {
  const hasId = fields.find(field => field.role === 'id')
  const hasName = fields.find(field => field.role === 'name')

  if (!hasId || !hasName) return false

  switch (type) {
    case 'TWO_NUMBERS':
      return fields.filter(field => field.role === 'value').length > 1
    case 'ONE_NUMBER':
      return fields.filter(field => field.role === 'value').length > 0
    default:
      return false
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/validations.js/validation.js